<template>
<v-card flat >
  <v-card-title class='subtitle-1 overline' >
  </v-card-title>
  <v-card-text class='text-center' style='max-width:380px;margin-left:auto;margin-right:auto;' >

    <v-btn block rounded x-large outlined
      v-for='action in actions' :key='action.id'
      v-on="action.events"
      @click='action.click'
      color='primary'
      class='mb-4' >
      <v-icon v-if='action.icon' >{{action.icon}}</v-icon>
      {{ action.text }}
    </v-btn>

    <v-btn block rounded x-large outlined
      v-if='withDone'
      color='primary'
      class='my-4'
      @click='$emit("close")' >
      Done
    </v-btn>

  </v-card-text>
  <!-- <pre v-text="value" /> -->
</v-card>
</template>
<script>
export default {
  name: 'SuccessScreen',
  props: {
    value: { type: Object },
    actions: { type: Array, default: () => { return [] } },
    withDone: { type: Boolean, default: true }
  },
  mounted () {
    if (this.actions && this.actions.length > 0) {
      this.withDone = false
    }
  }
}
</script>
